import { useAuth0 } from "@auth0/auth0-react"
import { Feed } from "semantic-ui-react"
import { isSuperAdminOrResellerAdminOrAdmin } from "../../../../Utils/util"
import ConfigureEthernetSettingsModal from "./ConfigureEthernetSettingsModal"

const ConfigureEthernetSettings = () => {
	const { user } = useAuth0()

	return (
		<>
			{isSuperAdminOrResellerAdminOrAdmin(user) && (
				<>
					<Feed.Event className="device-event-margin">
						<Feed.Content>
							<Feed.Summary content={"Ethernet Configuration"} />
							<Feed.Extra text content={<ConfigureEthernetSettingsModal />} />
						</Feed.Content>
					</Feed.Event>
				</>
			)}
		</>
	)
}

export default ConfigureEthernetSettings
